import { all, fork } from 'redux-saga/effects';

import registerSagas from './register/sagas';
import editSagas from './edit/sagas';
import bankAccountSagas from './bankAccount/sagas';

export default function* configSagas() {
  yield all([fork(registerSagas), fork(editSagas), fork(bankAccountSagas)]);
}
